import { SORT_ORDERS } from "constants/records";
import { FLSA_REPORT_STRINGS } from "./strings";

const { COLUMNS } = FLSA_REPORT_STRINGS;

const employeeOrderingValueMap = ({ field, order }) =>
  order === SORT_ORDERS.ASC ? `employee__${field}` : `-employee__${field}`;

export const FLSA_REPORT_COLUMNS = [
  {
    key: "first_name",
    label: COLUMNS.FIRST_NAME,
    sortable: true,
    orderingKey: "ordering",
    orderingValueMap: employeeOrderingValueMap,
  },
  {
    key: "last_name",
    label: COLUMNS.LAST_NAME,
    sortable: true,
    orderingKey: "ordering",
    orderingValueMap: employeeOrderingValueMap,
  },
  {
    key: "employee_id",
    label: COLUMNS.EMPLOYEE_ID,
    sortable: false,
  },
  {
    key: "week_start_date",
    label: COLUMNS.WEEK_START_DATE,
    sortable: false,
  },
  {
    key: "week_end_date",
    label: COLUMNS.WEEK_END_DATE,
    sortable: false,
  },
  {
    key: "qualified_ot",
    label: COLUMNS.QUALIFIED_OT,
    sortable: false,
  },
  {
    key: "qualified_dt",
    label: COLUMNS.QUALIFIED_DT,
    sortable: false,
  },
  {
    key: "total_qualified",
    label: COLUMNS.TOTAL_QUALIFIED,
    sortable: false,
  },
];
